import './icon-group.css';

const IconGroup = ({ children }) => {
  return <div className="icon-group">{children}</div>;
};

export default IconGroup;